import React from 'react';
import './History.css';
import Chip from '@mui/material/Chip';


function History() {
    const [show, setShow] = React.useState(false);

    return (<>
        <div className="community-section">
            <div className="community-inner-wrap subscriptions-block d-flex align-items-center justify-content-between">
                <div className="add-new-community d-flex justify-content-between align-items-center mb-0">
                    <div className="community-heading">History</div>
                </div>
            </div>
            <div className="all-commmunities-table">
                {/* <div className='billing-title allcommunities'>
                    Client Search
                </div> */}
                {/* <div className='input-search mt-2'>
                    <input type="text" placeholder="Start Typing here..." />
                </div> */}
                <div className='payments-table reports'>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Transaction ID</th>
                                <th scope="col">Date</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            <tr className='month'>
                            </tr>
                            <tr>
                                <td>T1</td>
                                <td>2/2/2035</td>
                                <td>$9.76</td>
                                <td><span
                                    class="badge rounded-pill text-bg-success"
                                    style={{ cursor: "default" }}
                                >
                                    Completed
                                </span></td>
                            </tr>
                            <tr>
                                <td>T2</td>
                                <td>2/2/2035</td>
                                <td>$9.76</td>
                                <td><span
                                    class="badge rounded-pill text-bg-warning"
                                    style={{ cursor: "default" }}
                                >
                                    Pending
                                </span></td>
                            </tr>
                            <tr>
                                <td>T3</td>
                                <td>2/2/2035</td>
                                <td>$9.76</td>
                                <td><span
                                    class="badge rounded-pill text-bg-danger"
                                    style={{ cursor: "default" }}
                                >
                                    Failed
                                </span></td>
                            </tr>
                            <tr className='month border-top '>
                                <td>Total</td>
                                <td></td>
                                <td><span>$</span>19.52</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {show ? <div className="all-commmunities-table">
                <div className='title-modal'>Ad Banner</div>
                <div className=''>
                    <div className='table-modal'>
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>Miller Ale House</td>
                                    <td>Jupiter FL</td>
                                    <td>$79.95</td>
                                </tr>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>State Farm Insurance</td>
                                    <td>Jupiter FL</td>
                                    <td>$79.95</td>
                                </tr>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>Jupiter Medical Center</td>
                                    <td>Stuart FL</td>
                                    <td>$79.95</td>
                                </tr>
                                <tr>
                                    <td>2/3/2025</td>
                                    <td>Keller Williams Realty</td>
                                    <td>Stuart FL</td>
                                    <td>$79.95</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : null}
        </div>
    </>);
}

export default History;